import { BaseEntity } from './base-entity';
import { RiskFactorType } from './risk-factor-type';
import { RiskFactorRank } from './risk-factor-rank';

export class RiskFactor extends BaseEntity {
  description: string;
  type: RiskFactorType;
  ranks: Array<RiskFactorRank>; // ranks
  numericValue?: number;
}
